import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import image from "_assets/images/PRM-Logo-PNG/iphone-android.png";

const IphoneAndroid = () => {
    return (
        <>
          <Container>
            <Row>
              <div>
                <img
                  src={image}
                  height={600}
                />
              </div>
            </Row>
          </Container>      
        </>
    );
};

export default IphoneAndroid;
